var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL OPERATIONS","title":"Hostel Management","description":"Manage hostels, rooms, bed assignments and visitor records.","count-label":"hostel tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }